import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseMapAssetModel, BaseMapSubAssetModel } from '../../interfaces/base-map.interface';

@Component({
    selector: 'app-geomap-marker-park',
    templateUrl: './geomap-marker-park.component.html',
    styleUrls: ['./geomap-marker-park.component.scss'],
    standalone: false
})
export class GeomapMarkerParkComponent implements OnInit {

  @Input() asset: BaseMapAssetModel;
  @Input() data: any;
  @Input() active: boolean;
  @Input() statusHour: number;
  @Input() statusColors: string[];
  @Input() cantRedirectToSubAsset = true;
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() redirectToAsset: EventEmitter<any> = new EventEmitter<any>();
  @Output() redirectToSubAsset: EventEmitter<any> = new EventEmitter<any>();

  public showAll = false;
  public turbinesLimit = 7;
  public turbineTypeStrings: Array<any>;

  private subAsset: BaseMapSubAssetModel[];

  ngOnInit() {
    if (!this.subAsset) {
      this.subAsset = [];
    }
  }

  @Input() set subAssets(subAssets: Array<BaseMapSubAssetModel>) {
    if (subAssets) {
      this.subAsset = subAssets;
      this.turbineTypeStrings = this.turbineTypesStrings();
    }
  }

  get subAssets(): BaseMapSubAssetModel[] {
    return this.subAsset;
  }

  toggleShowAll = (event) => {
    event.stopPropagation();
    this.showAll = !this.showAll;
    this.changed.emit(this.showAll);
  }

  private turbineTypesStrings() {
    const turbs = this.subAsset;
    const typeGroups = {};

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < turbs.length; i++) {

      const turb = turbs[i];

      if ((!turb.typeDisplayName || !turb.type) && !turb.hubHeight) {
        continue;
      }

      const key = (turb.typeDisplayName || turb.type) + turb.hubHeight;

      if (typeGroups[key]) {
        typeGroups[key].count++;
      } else {
        typeGroups[key] = {displayName: (turb.typeDisplayName || turb.type), height: turb.hubHeight, count: 1};
      }
    }

    const typesStrings = [];

    for (const type in typeGroups) {
      if (type) {
        const group = typeGroups[type];
        typesStrings.push({type: (group.count + ' x ' + group.displayName), height: ('at ' + group.height + 'm')});
      }
    }

    return typesStrings;
  }

}
